<template>
  <span class="bg-error-1 flex h-3 w-3 grow-0 rounded-full">
    <svg
      width="4"
      height="4"
      class="m-auto"
      viewBox="0 0 4 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 1C4 0.447715 3.55228 0 3 0H1C0.447715 0 0 0.447715 0 1V3C0 3.55228 0.447715 4 1 4H3C3.55228 4 4 3.55228 4 3V1Z"
        fill="white"
      />
    </svg>
  </span>
</template>
